import { EntityTypeConfigrationService } from './../services/basic/entity-type-configration.service';
import { UserClaimsService } from './../services/basic/user-claims.service';
import { autoinject } from "aurelia-dependency-injection";
import type { EntityTypeConfigurationModel } from "../components/comp-entity-finder/comp-entity-finder.models";
import * as Enumerable from "linq";


@autoinject
export class EntityTypeConfigurationHelper {
    
    constructor(private userClaimsService: UserClaimsService, private entityTypeConfigrationService: EntityTypeConfigrationService) { }

    public getConfigurationWithoutPermissions(entityUriList: string[], configuration: EntityTypeConfigurationModel[] = null): EntityTypeConfigurationModel[] {
        return Enumerable.from(configuration && configuration.length > 0 ? configuration : this.entityTypeConfigrationService.getAllConfigs())
            .where(x => entityUriList.length === 0 || Enumerable.from(entityUriList).contains(x.uri))
            .toArray();
    }

    public getConfiguration(entityUriList: string[], configuration: EntityTypeConfigurationModel[] = null): EntityTypeConfigurationModel[] {
        return Enumerable.from(configuration && configuration.length > 0 ? configuration : this.entityTypeConfigrationService.getAllConfigs())
            .where(x => entityUriList.length === 0 || Enumerable.from(entityUriList).contains(x.uri))
            .where(x => entityUriList.length === 0 || this.userClaimsService.hasPermissions(x.claims))
            .toArray();
    }

    public getConfigurationByKey(keys: string[], configuration: EntityTypeConfigurationModel[] = null): EntityTypeConfigurationModel[] {
        return Enumerable.from(configuration && configuration.length > 0 ? configuration : this.entityTypeConfigrationService.getAllConfigs())
            .where(x => x.key && x.key.length === 0 || Enumerable.from(keys).contains(x.key))
            .where(x => x.key && x.key.length === 0 || this.userClaimsService.hasPermissions(x.claims))
            .toArray();
    }
}